/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Validation_Invalid_UrlInputs */

const en_profile_validation_invalid_url = /** @type {(inputs: Profile_Validation_Invalid_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar URL must be a valid URL.`)
};

const pt_br2_profile_validation_invalid_url = /** @type {(inputs: Profile_Validation_Invalid_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A URL do avatar deve ser válida.`)
};

/**
* | output |
* | --- |
* | "Avatar URL must be a valid URL." |
*
* @param {Profile_Validation_Invalid_UrlInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_validation_invalid_url = /** @type {((inputs?: Profile_Validation_Invalid_UrlInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Validation_Invalid_UrlInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_validation_invalid_url(inputs)
	return pt_br2_profile_validation_invalid_url(inputs)
});